import { useCallback } from 'react';

export const useGetRowHeight = () => useCallback(() => 'auto', []);
